<template>
  <section class="produto-varejo-inteligente-formulario-estacao-trabalho">
    <div class="content">
      <Titulo
        title="Dados da Reserva"
        description="Informe os dados necessários para a reserva."
      />
      <div class="mt-1 form-wrap px-4 pb-4">
        <div class="row">
          <div class="col-md-6 mt-4 mt-md-0">
            <FormulateInput
              type="text"
              v-model="form.responsavel"
              validation="required"
              label="Nome do responsável"
              @input="validarDados"
            />
          </div>
          <div class="col-md-3 mt-4 mt-md-0">
            <FormulateInput
              type="text"
              v-model="form.telefone"
              validation="required"
              v-mask="'(##) #####-####'"
              label="Telefone de contato"
              @input="validarDados"
            />
          </div>
          <div class="col-md-3 mt-4 mt-md-0">
            <FormulateInput
              type="email"
              v-model="form.email"
              validation="email|required"
              label="E-mail de contato"
              @input="validarDados"
            />
          </div>
          <div class="col-md-6 mt-4 mt-md-0" v-if="escritorioVirtual">
            <FormulateInput
              type="date"
              name="dataInicio"
              placeholder="Data de início"
              v-model="form.dataInicio"
              :validation="`required|after:${dataInicioValidation}`"
              :validation-messages="{
                after: `A Data Inicio deve ser posterior a ${msgInicioValidation}`,
              }"
              label="Data Início"
              @input="validarDados"
              :min="dataInicioEscVirtual"
            />
          </div>
          <div class="col-md-6 mt-4 mt-md-0" v-if="escritorioVirtual">
            <FormulateInput
              type="date"
              name="dataFim"
              placeholder="Data Final"
              v-model="form.dataFim"
              :validation="`required|after:${dataFimValidation}`"
              :validation-messages="{
                after: `A Data Final deve ser posterior a ${msgFimValidation}`,
              }"
              label="Data Final"
              @input="validarDados"
              :min="dataMinFimEscVirtual"
            />
          </div>
        </div>
      </div>
      <div class="row mt-4" v-if="!escritorioVirtual">
        <div
          class="col-md-4"
          :class="{ 'd-none d-md-block': registroSel !== null }"
        >
          <div v-for="(registro, index) in lista" :key="index">
            <button
              class="btn btn-block btn-light justify-content-start mb-2 rounded"
              type="button"
              @click="selecionaCadastro(index)"
              :class="{ active: registroSel === index }"
              v-if="registro.value"
            >
              <div class="text-left">
                <div class="label text-muted">
                  {{ registro.label }}
                </div>
                <div class="value">
                  {{ registro.value }}
                </div>
                <div
                  v-if="!registro.concluido"
                  class="text-danger text-small d-flex align-items-center"
                >
                  <span class="material-icons mr-1 text-small">
                    warning_amber
                  </span>
                  Cadastro incompleto
                </div>
                <div v-else class="text-success text-small font-weight-bold">
                  <span class="material-icons mr-1 text-small"> done </span>
                  Cadastro completo
                </div>
              </div>
            </button>
          </div>
        </div>
        <div class="d-none d-md-flex col-md-8" v-if="registroSel === null">
          <div class="alert alert-info d-flex align-items-center">
            <span class="material-icons"> arrow_back_ios </span> Clique nos
            botões ao lado para preencher os dados para cada reserva.
          </div>
        </div>
        <div class="col-md-8" v-show="registroSel !== null">
          <div class="card card-body">
            <div class="mb-1 border-bottom pb-3 row">
              <div class="col-md-5">
                <div class="value">{{ nome }}</div>
              </div>
            </div>
            <FormulateForm
              name="Cadastro"
              v-model="values"
              @submit="salvarRegistro"
            >
              <FormulateInput
                type="text"
                name="nome"
                label="Nome Completo"
                validation="required"
              />
              <FormulateInput
                type="text"
                name="telefone"
                label="Telefone"
                validation="required"
                v-mask="'(##) #####-####'"
              />
              <FormulateInput
                type="text"
                name="rg"
                label="RG"
                validation="required"
              />
              <FormulateInput
                type="text"
                name="cpf"
                label="CPF"
                validation="required"
                v-mask="'###.###.###-##'"
                @change="validarCpf()"
              />
              <FormulateInput type="submit" value="Salvar" />
            </FormulateForm>
          </div>
        </div>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            v-if="escritorioVirtual"
            title="Voltar"
            :link="`/produto/cdl-varejo-inteligente/produtos`"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
          <Botao
            v-else
            title="Voltar"
            :link="`/produto/cdl-varejo-inteligente/estacao-trabalho/${session.idAgenda}`"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
        <div class="col-md-4 col-lg-2">
          <Botao
            title="Próximo"
            nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
            @click="disabled ? false : salvarApi()"
            :disabled="disabled"
            :class="{ disabled: disabled }"
            >PRÓXIMO</Botao
          >
        </div>
      </div>
    </div>
    <div class="py-5"></div>
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import { clearStr, validateCPF } from "../../../helpers";
export default {
  name: "CdlSaude",
  components: { Titulo, Botao },
  data() {
    return {
      form: {
        responsavel: "",
        telefone: "",
        email: "",
        dataInicio: "",
        dataFim: "",
      },
      values: {},
      registroSel: 0,
      produto: {
        nome: "CDL Varejo Inteligente",
        id: "CDL Varejo Inteligente",
      },
      breadcrumb: [
        {
          nome: "CDL Varejo Inteligente",
          id: "CDL Varejo Inteligente",
          link: "/produto/cdl-varejo-inteligente",
        },
        {
          nome: "Formulário",
          id: "formulario",
          produto: "CDL Varejo Inteligente",
        },
      ],
      lista: [],
      nome: null,
      posicoes: [],
      dadosReserva: null,
      disabled: true,
      escritorioVirtual: false,
      session: null,
      tipoReserva: null,
      dataInicioEscVirtual: null,
      dataMinFimEscVirtual: null,
      dataInicioValidation: null,
      msgInicioValidation: null,
      dataFimValidation: null,
      msgFimValidation: null,
    };
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  methods: {
    montarDados() {
      this.session = JSON.parse(sessionStorage.getItem("reserva"));
      if (this.session.dadosReserva) {
        this.session.dadosReserva.estacoes.forEach((posicao, k) => {
          this.lista.push({
            label: "Dados pessoais",
            value: "Reserva " + (parseInt(k) + 1),
            posicao: posicao,
            concluido: false,
          });
        });
        this.nome = this.lista[this.registroSel].value;

        if (this.session.formulario) {
          this.form = this.session.formulario.dados;
          this.posicoes = this.session.formulario.posicoes;
          this.lista = this.session.formulario.lista;
          this.registroSel = null;
        }
      } else {
        this.escritorioVirtual = true;
      }
    },
    selecionaCadastro(id) {
      this.$formulate.reset("Cadastro");
      this.registroSel = id;
      this.nome = this.lista[id].value;
      if (this.posicoes[id]) {
        this.values = this.posicoes[this.registroSel];
      }
    },
    salvarRegistro() {
      this.posicoes[this.registroSel] = this.values;
      this.lista[this.registroSel].concluido = true;
      this.$formulate.reset("Cadastro");
      this.registroSel = null;
      this.validarDados();

      this.session.formulario = {
        dados: this.form,
        posicoes: this.posicoes,
        lista: this.lista,
      };

      sessionStorage.setItem("reserva", JSON.stringify(this.session));
    },
    validarCpf() {
      var cpf = clearStr(this.values.cpf);

      const result = validateCPF(cpf);
      if (!result) {
        this.invalidCpf = true;
        this.$formulate.handle(
          {
            inputErrors: { cpf: "CPF Inválido!" },
            hasErrors: { cpf: true },
          },
          "Cadastro"
        );
      } else {
        this.invalidCpf = false;
        this.$formulate.handle({ inputErrors: { cpf: null } }, "Cadastro");
      }
    },
    validarDados() {
      if (this.form.responsavel && this.form.telefone && this.form.email) {
        this.disabled = false;
        this.lista.forEach((el) => {
          if (!el.concluido) {
            this.disabled = true;
          }
        });
      }
    },
    salvarApi() {
      var dados = [];
      if (this.escritorioVirtual) {
        dados = {
          agendaId: this.session.idAgenda,
          titulo: this.form.responsavel,
          descricao: `Responsavel: ${this.form.responsavel}, telefone: ${this.form.telefone}, email: ${this.form.email}`,
          inicio: this.form.dataInicio,
          fim: this.form.dataFim,
        };
        this.session.tipoReserva = "escritorio-virtual";
        this.session.formulario = { dados: this.form };
      } else {
        var estacoes = [];

        this.lista.forEach((lista, k) => {
          estacoes.push({
            posicao: lista.posicao,
            nome: this.posicoes[k].nome,
            telefone: clearStr(this.posicoes[k].telefone),
            rg: clearStr(this.posicoes[k].rg),
            cpf: clearStr(this.posicoes[k].cpf),
          });
        });

        dados = {
          agendaId: this.session.idAgenda,
          titulo: this.form.responsavel,
          descricao: `Responsavel: ${this.form.responsavel}, telefone: ${this.form.telefone}, email: ${this.form.email}`,
          inicio: this.session.dadosReserva.dataInicio,
          fim: this.session.dadosReserva.dataFim,
          estacoes: estacoes,
          responsavel: this.form.responsavel,
          telefone: this.form.telefone,
          email: this.form.email,
        };
      }
      this.session.simularDados = dados;
      sessionStorage.setItem("reserva", JSON.stringify(this.session));
      this.$router.push({ name: "termoVarejo" });
    },
    validarData() {
      const date = new Date();
      const dateValidation = new Date();
      date.setDate(date.getDate() + 1);

      this.dataInicioEscVirtual =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);

      date.setMonth(date.getMonth() + 1);

      this.dataMinFimEscVirtual =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);

      this.dataInicioValidation =
        dateValidation.getFullYear() +
        "-" +
        ("0" + (dateValidation.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + dateValidation.getDate()).slice(-2);

      this.msgInicioValidation =
        ("0" + dateValidation.getDate()).slice(-2) +
        "/" +
        ("0" + (dateValidation.getMonth() + 1)).slice(-2) +
        "/" +
        dateValidation.getFullYear();

      dateValidation.setMonth(dateValidation.getMonth() + 1);
      this.dataFimValidation =
        dateValidation.getFullYear() +
        "-" +
        ("0" + (dateValidation.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + dateValidation.getDate()).slice(-2);

      this.msgFimValidation =
        ("0" + dateValidation.getDate()).slice(-2) +
        "/" +
        ("0" + (dateValidation.getMonth() + 1)).slice(-2) +
        "/" +
        dateValidation.getFullYear();
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.session = JSON.parse(sessionStorage.getItem("reserva"));
    if (this.session && this.session.formulario) {
      this.form = this.session.formulario.dados;
      this.disabled = false;
    }

    if (
      this.urlParams.tipoReserva &&
      this.urlParams.tipoReserva === "escritorio-virtual"
    ) {
      this.escritorioVirtual = true;
      this.session = {
        idAgenda: this.urlParams.idAgenda,
      };
      this.validarData();
    } else {
      this.montarDados();
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.produto-varejo-inteligente-formulario-estacao-trabalho /deep/ {
  /* @import "../../../../node_modules/@braid/vue-formulate/themes/snow/snow.scss"; */
  @import "@/assets/scss/_vue-formulate.scss";
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }
    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
    }
  }
  .form-wrap {
    background: $dark-100;
    border-radius: 6px;
    .formulate-input {
      .formulate-input-element {
        background: white;
        input,
        select {
          background: white;
        }
      }
    }
  }
}
.label {
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 3px;
  text-transform: capitalize;
}
.value {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
